import {
  LinkAuthenticationElement,
  PaymentElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import { FormEvent, useEffect, useState } from "react";
import { Button } from "../../../components/ui/button";
import { Card, CardContent } from "../../../components/ui/card";
import { Input } from "../../../components/ui/input";
import { Config } from "../../../utils/config";
import PlaceOrder from "../../place-order/PlaceOrder";
import fetchData from "../../../utils/api";
import { getI18n } from "react-i18next";
import { toast } from "../../../components/ui/use-toast";
import { t } from "i18next";

export default function CheckoutForm({
  email,
  id,
  cartId,
  authToken,
  setCurrentSelected,
  setIsPlaceOrder,
  setIsHeader,
  restaurantDetail,
  setIsOnlinePayment,
  clientSecret,
  setCartTotal,
  orderingMethod,
}) {
  const stripe = useStripe();
  const elements = useElements();
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [updatedEmail, setUpdatedEmail] = useState(email || "");
  const [paymentConfirmed, setPaymentConfirmed] = useState(false);
  const currentLanguage = getI18n();

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!stripe || !elements) {
      return;
    }
    setIsLoading(true);
    const { error: submitError } = await elements.submit();
    if (submitError) {
      console.error(submitError);
      return;
    }
    const { error, paymentIntent, ...rest }: any = await stripe.confirmPayment({
      elements,
      clientSecret: clientSecret,
      redirect: "if_required",
      confirmParams: {
        return_url: `${window.location.origin}/order-placed?token=${Config.env.app.token}&cartId=${cartId}&authToken=${authToken}&id=${id}&type=${orderingMethod}&language=${currentLanguage.language}`,
      },
    });

    if (paymentIntent.status === "succeeded") {
      let body = {
        cart_id: cartId,
        language: currentLanguage.language,
        paymentIntent: paymentIntent.id,
      };
      const res = await fetchData({
        url: "cart/place-online-order",
        method: "POST",
        body,
        token: authToken,
      });
      if (res.status === "success") {
        const params = new URLSearchParams(window.location.search);
        const newUrl = `/order-placed?${params.toString()}&cartId=${cartId}&authToken=${authToken}`;
        window.location.href = newUrl;
        // setPaymentConfirmed(true);
        // setIsPlaceOrder(true);
        // setCurrentSelected("cart");
      } else {
        setCurrentSelected("cart");
        toast({
          title: t("payment_failed.title"),
          description: t("payment_failed.description"),
        });
      }
    } else if (
      error.type === "card_error" ||
      error.type === "validation_error"
    ) {
      setMessage(error.message);
      setIsOnlinePayment(false);
      setIsHeader(true);
      setCurrentSelected("cart");
    } else {
      setMessage("An unexpected error occurred.");
    }
    setIsLoading(false);
  };

  return (
    <div>
      {/* {paymentConfirmed ? (
        <PlaceOrder
          authToken={authToken}
          cartId={cartId}
          id={id}
          setIsPlaceOrder={setIsPlaceOrder}
          setCurrentSelected={setCurrentSelected}
          setIsHeader={setIsHeader}
          restaurantDetail={restaurantDetail}
          setCartTotal={setCartTotal}
        />
      ) : ( */}
      <form id="payment-form" onSubmit={handleSubmit} className="space-y-2">
        <div>
          <Card>
            <CardContent className="grid gap-2 p-4">
              <Input disabled type="email" value={updatedEmail} />
              {/* <LinkAuthenticationElement
          onChange={(e) => {
            setUpdatedEmail(e.value.email);
          }}
          options={{ defaultValues: { email: email || "" } }}
        /> */}
              <PaymentElement id="payment-element" />
              <Button disabled={isLoading}>Submit</Button>
            </CardContent>
          </Card>
        </div>
        {message && <div id="payment-message">{message}</div>}
      </form>
      {/* )} */}
    </div>
  );
}
